// extracted by mini-css-extract-plugin
module.exports = {"lpPageWrapper":"Home_lpPageWrapper__2RpVn","loginPage":"Home_loginPage__ksDB9","loginCard":"Home_loginCard__2wotW","lpFooter":"Home_lpFooter__29MZg"};